// File: Visa.jsx

"use client"

import { useState, useEffect, useRef } from "react"
import "./Visa.css"

const Visa = ({ countryData }) => {
  const [activeVisaIndex, setActiveVisaIndex] = useState(0)
  const autoPlayRef = useRef(null)

  // Use visa data from countryData, wrapping single object in an array
  const visaTypes = countryData.visa?.types
    ? Array.isArray(countryData.visa.types)
      ? countryData.visa.types
      : [countryData.visa.types]
    : [
        {
          title: "Short-term Study",
          cost: "£ 94",
          type: "Type- Study",
          description:
            "If you want to do a short course of study in the UK, such as an English language course or a training course or do a short period of research as part",
        },
        {
          title: "General Student - Tier 4",
          cost: "£ 339",
          type: "Type- Study",
          description:
            "This category is for students coming to the UK for post-16 education. A Tier 4 (General) Student must be at least 16 years old.",
        },
        {
          title: "Child Student - Tier 4",
          cost: "£ 339",
          type: "Type- Study",
          description:
            "You can apply for the Tier 4 (Child) student visa if you are aged between 4 and 17 and you want to study at an independent school in the UK.",
        },
      ]

  // Use weather data from countryData
  const weatherData = countryData.weather || [
    { city: "London", min: "100°", max: "18°" },
    { city: "Edinburgh", min: "6°", max: "14°" },
    { city: "Manchester", min: "9°", max: "15°" },
    { city: "Glasgow", min: "8°", max: "15°" },
    { city: "Coventry", min: "9°", max: "17°" },
    { city: "Nottingham", min: "7°", max: "17°" },
    { city: "Birmingham", min: "7°", max: "16°" },
    { city: "New Castle", min: "12°", max: "14°" },
    { city: "Aberdeen", min: "6°", max: "14°" },
    { city: "Brighton", min: "10°", max: "14°" },
  ]

  // Auto-play functionality
  useEffect(() => {
    autoPlayRef.current = setTimeout(() => {
      setActiveVisaIndex((prev) =>
        prev === visaTypes.length - 1 ? 0 : prev + 1
      )
    }, 5000)

    return () => {
      if (autoPlayRef.current) {
        clearTimeout(autoPlayRef.current)
      }
    }
  }, [activeVisaIndex, visaTypes.length])

  const handlePrevVisa = () => {
    if (autoPlayRef.current) {
      clearTimeout(autoPlayRef.current)
    }
    setActiveVisaIndex((prev) =>
      prev === 0 ? visaTypes.length - 1 : prev - 1
    )
  }

  const handleNextVisa = () => {
    if (autoPlayRef.current) {
      clearTimeout(autoPlayRef.current)
    }
    setActiveVisaIndex((prev) =>
      prev === visaTypes.length - 1 ? 0 : prev + 1
    )
  }

  return (
    <div className="post-admission-container">
      <h1>Post Admission Experience</h1>

      <div className="visa-weather-grid">
        <div className="visa-section">
          <h2>Visa for {countryData.name}</h2>

          <div className="visa-slider">
            <button className="visa-nav prev" onClick={handlePrevVisa}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15 18L9 12L15 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            <div className="visa-cards-container">
              {visaTypes.map((visa, index) => (
                <div
                  key={index}
                  className={`visa-card ${
                    activeVisaIndex === index ? "active" : ""
                  }`}
                  style={{
                    backgroundColor:
                      index === 0
                        ? "#e0f7fa"
                        : index === 1
                        ? "#f0f0ff"
                        : "#e8eaf6",
                  }}
                >
                  <h3>{visa.title}</h3>
                  <div className="visa-details">
                    <p className="visa-cost">Cost - {visa.cost}</p>
                    <p className="visa-type">{visa.type}</p>
                  </div>
                  <p className="visa-description">{visa.description}</p>
                </div>
              ))}
            </div>

            <button className="visa-nav next" onClick={handleNextVisa}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 18L15 12L9 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>

          <div className="explore-more-container">
            <button className="explore-more-btn">Explore More</button>
          </div>
        </div>

        <div className="weather-section">
          <h2>Weather</h2>

          <div className="weather-grid">
            {weatherData.map((city, index) => (
              <div key={index} className="weather-card">
                <div className="city-name">{city.city}</div>
                <div className="temp-values">
                  <div className="label">Min</div>
                  <div className="label">Max</div>
                </div>
                <div className="temps">
                  <span className="temp min">{city.min}</span>
                  <span className="temp max">{city.max}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Visa
